import { render, staticRenderFns } from "./JourneyDropdown.vue?vue&type=template&id=a49f70a6&"
import script from "./JourneyDropdown.vue?vue&type=script&lang=js&"
export * from "./JourneyDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a49f70a6')) {
      api.createRecord('a49f70a6', component.options)
    } else {
      api.reload('a49f70a6', component.options)
    }
    module.hot.accept("./JourneyDropdown.vue?vue&type=template&id=a49f70a6&", function () {
      api.rerender('a49f70a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/JourneyDropdown.vue"
export default component.exports